/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { HeroFlattenImage as HeroFlattenImageComponent } from '@thd-olt-component-react/hero';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { number, string } from 'prop-types';
import { HomepageContext } from './context/HomepageContext';

export function HeroFlattenImage({
  id,
  layoutRendererPrerenderedChildIndex
}) {

  const { proCustomerSegment, isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="hero-flatten-image">
      <QueryProvider cacheKey="hero-flatten-image-cache" defaultVariables={{ isCarousel: false }}>
        <HeroFlattenImageComponent
          componentId={id}
          layoutRendererPrerenderedChildIndex={layoutRendererPrerenderedChildIndex}
          isB2C={isB2C}
          proCustomerSegment={proCustomerSegment}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

HeroFlattenImage.propTypes = {
  id: string,
  layoutRendererPrerenderedChildIndex: number,
};

HeroFlattenImage.defaultProps = {
  id: '',
  layoutRendererPrerenderedChildIndex: undefined
};
